import React, { useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../../firebase-config";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: 45,
        fontSize: 16
    }
}));

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright '}
            <Link color="inherit" href="https://LogicLovers.ru">
                LogicLovers.ru
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const SignIn = () => {
    const classes = useStyles();
    const [errorMessage, setErrorMessage] = useState('');
    const history = useHistory();
    const location = useLocation<{ from?: string }>();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (user && location.state?.from) {
                history.push(location.state.from);
            }
        });
        return () => unsubscribe();
    }, [history, location.state]);

    const handleGoogleSignIn = async () => {
        try {
            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            localStorage.setItem('token', await user.getIdToken());
            localStorage.setItem('username', user.displayName || '');
            localStorage.setItem('photoURL', user.photoURL || '');

            const redirectPath = location.state?.from || '/';
            history.push(redirectPath);

        } catch (error) {
            console.error('Ошибка авторизации:', error);
            setErrorMessage('Ошибка входа через Google. Попробуйте ещё раз.');
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <NavLink to={location.state?.from || '/'}>
                    <Button style={{ marginTop: 10, marginRight: 100 }}>
                        Назад
                    </Button>
                </NavLink>
            </div>
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Авторизация
                </Typography>
                <div className={classes.form}>
                    {errorMessage && (
                        <Typography color="error" align="center">
                            {errorMessage}
                        </Typography>
                    )}
                    <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        className={classes.submit}
                        onClick={handleGoogleSignIn}
                        // startIcon={
                        //     <img
                        //         src="/google-logo.png"
                        //         alt="Google"
                        //         style={{ width: 20, marginRight: 10 }}
                        //     />
                        // }
                    >
                        Войти через Google
                    </Button>

                    <Typography variant="body2" style={{ marginTop: 20, textAlign: 'center' }}>
                        Нажимая «Войти через Google», вы соглашаетесь с<br/>
                        <Link href="/privacy-policy" color="secondary">
                            Политикой конфиденциальности
                        </Link>
                    </Typography>
                </div>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>
        </Container>
    );
};

export default SignIn;
